import script from "./Commissions.vue?vue&type=script&lang=ts&setup=true"
export * from "./Commissions.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__